import React from 'react';
import { cond, find, prop, propEq, sortBy } from 'ramda';
import { withPrefix } from 'gatsby';

import { renderWhenTrue } from '../../utils/rendering';
import {
  Container,
  TitleWrapper,
  Title,
  CaptionWrapper,
  Caption,
  CaptionArrow,
  ImageComponent,
  FootnoteWrapper,
  Footnote,
} from './image.styles';
import { useIntl } from 'gatsby-plugin-intl';

const renderTitle = ({ value }, key) => {
  const intl = useIntl();
  return renderWhenTrue(() => (
    <TitleWrapper key={key}>
      <Title>{intl.formatMessage({ id: value })}</Title>
    </TitleWrapper>
  ))(!!value);
};

// const renderCaption = ({ value }, key) => {
//   const intl = useIntl();
//   return renderWhenTrue(() => (
//     <CaptionWrapper key={key}>
//       <Caption>{intl.formatMessage({ id: value })}</Caption>
//       <CaptionArrow />
//     </CaptionWrapper>
//   ))(!!value);
// };

const renderCaption = (caption) => {
  if(!caption.value) return null
  const intl = useIntl();
  return renderWhenTrue(() => <Caption>{intl.formatMessage({ id: caption.value })}</Caption>)(!!caption);
};

const renderImage = ({ url }, key) => renderWhenTrue(() => <ImageComponent image={withPrefix(url)} key={key} />)(!!url);

const renderFootnote = ({ value }, key) => {
  const intl = useIntl();
  return renderWhenTrue(() => (
    <FootnoteWrapper key={key}>
      <Footnote>{intl.formatMessage({ id: value })}</Footnote>
    </FootnoteWrapper>
  ))(!!value);
};

const renderElement = cond([
  [propEq('name', 'Title'), renderTitle],
  [propEq('name', 'Caption'), renderCaption],
  [propEq('name', 'Image'), renderImage],
  [propEq('name', 'Footnote'), renderFootnote],
]);

export const Image = ({ elements }) => {
  const orderedElements = sortBy(prop('order'))(elements);

  // QUICK FIX (TO IMPROVE)
  const { url = '' } = find(propEq('name', 'Image'))(orderedElements) || {};
  const displayAsCard = !!(url.toLowerCase().match(/pi[l]*ar/g) || []).length;

  return (
    <Container displayAsCard={displayAsCard}>
      {orderedElements.map(renderElement)}
    </Container>
  )
};
